if (!window.productCardSmellMe) {
  window.productCardSmellMe = true;

  const getModal = () => {
    let modal = document.querySelector("[data-smell-me-modal]");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.className = "product-card-smell-modal buff-section-2025";
    modal.hidden = true;
    modal.setAttribute("data-smell-me-modal", "");
    modal.innerHTML = `
      <div class="product-card-smell-modal__overlay" data-smell-me-close></div>
      <div class="product-card-smell-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="Smell-me-title">
        <div class="product-card-smell-modal__header">
          <h2 class="product-card-smell-modal__marquee" id="Smell-me-title">
            <span></span>
          </h2>
          <button class="product-card-smell-modal__close btn" type="button" aria-label="Close" data-smell-me-close>&times;</button>
        </div>
        <div class="product-card-smell-modal__images"></div>
      </div>
    `;

    document.body.appendChild(modal);
    return modal;
  };

  const closeModal = () => {
    const modal = document.querySelector("[data-smell-me-modal]");
    if (!modal) return;

    modal.hidden = true;
    modal.querySelector(".product-card-smell-modal__images").innerHTML = "";
    document.body.style.overflow = "";
  };

  const openModal = (trigger) => {
    const card = trigger.closest("product-form");
    const dataScript = card?.querySelector("[data-smell-me-images]");
    if (!dataScript) return;

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error("Smell Me image data could not be parsed.", error);
      return;
    }

    if (!data.images?.length) return;

    const modal = getModal();
    const title = modal.querySelector("#Smell-me-title");
    const titleText = title.querySelector("span");
    const images = modal.querySelector(".product-card-smell-modal__images");
    const triggerStyles = getComputedStyle(trigger);

    ["--color-background", "--color-text"].forEach((property) => {
      const value = triggerStyles.getPropertyValue(property).trim();
      if (value) {
        modal.style.setProperty(property, value);
      }
    });

    if (data.color) {
      modal.style.setProperty("--scent-color", data.color);
      modal.style.setProperty("--color-foreground", data.color);
    }

    if (data.textColor) {
      modal.style.setProperty("--color-foreground-text", data.textColor);
    }

    const smellsLike = data.smellsLike || "Smells Like";
    titleText.textContent = smellsLike;
    titleText.dataset.text = smellsLike;

    images.innerHTML = data.images.map((image) => `
      <div class="product-card-smell-modal__image __loading">
        <img src="${image.src}" alt="${image.alt || data.title || ""}" loading="lazy" decoding="async">
      </div>
    `).join("");

    images.querySelectorAll("img").forEach((image) => {
      const imageItem = image.closest(".product-card-smell-modal__image");
      const setLoaded = () => imageItem?.classList.remove("__loading");

      if (image.complete) {
        setLoaded();
      } else {
        image.addEventListener("load", setLoaded, { once: true });
        image.addEventListener("error", setLoaded, { once: true });
      }
    });

    modal.hidden = false;
    document.body.style.overflow = "hidden";
    modal.querySelector(".product-card-smell-modal__close").focus();
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-smell-me-trigger]");
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
      return;
    }

    if (event.target.closest("[data-smell-me-close]")) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeModal();
    }
  });
}
